module.exports = __webpack_public_path__ + "img/thumbnail_Platypus_m_normal.7f1c3405.png";